import GroupsTableHeader from './GroupsTableHeader'
export default GroupsTableHeader
